"use client";

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const MarketingPage = () => {
  const navigate = useNavigate();
  const { storeType, storeId } = useParams<{
    storeType: string;
    storeId: string;
  }>();

  useEffect(() => {
    // Redirect to automation page as default
    navigate(`/${storeType}/${storeId}/marketing/automation`, { replace: true });
  }, [navigate, storeType, storeId]);

  return (
    <div className="flex items-center justify-center h-64">
      <p className="text-muted-foreground">Redirecting to automation...</p>
    </div>
  );
};

export default MarketingPage;
